// UPSELL
export const SUNTAGO_BUS_PRICE = 900
export const MEMORY_CAPTURE_PRICE = 5000
export const CABANA_PRICE = 9900
export const CABANA_INCOMING_PRICE = 14900
export const CABANA_LOWEST_PRICE = 9900
export const WELLNESS_PRICE = 12900
export const SURF_AIR_PRICE = 4000
export const BUNGALOW_PRICE = 55000
export const BUNGALOW_DUO_PRICE = 110000

// SELFCARE
export const OPERATING_FEE = 1000
export const FAMILY_PACKAGE_OPERATING_FEE = 2000
export const VOUCHER_DELIVERY_PRICE = 1500

// TODD: make sure is correct price
// UNLIMITED
export const CARD_DELIVERY_PRICE = 1500

// MARCH PROMO
export const MARCH_PROMO_STANDARD_VOUCHER_PRICE = 3000
export const MARCH_PROMO_PROLONGED_VOUCHER_PRICE = 5000
export const MARCH_PROMO_SELFCARE_VOUCHER_PRICE = 9900

// CITY BREAK PROMO
export const CITY_BREAK_TICKET_PRICE = 7500
